import { render, staticRenderFns } from "./PFruns.vue?vue&type=template&id=7b593e9a"
import script from "./PFruns.vue?vue&type=script&lang=js"
export * from "./PFruns.vue?vue&type=script&lang=js"
import style0 from "./PFruns.vue?vue&type=style&index=0&id=7b593e9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports